import script from "./CustomRadioGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomRadioGroup.vue?vue&type=script&setup=true&lang=ts"

import "./CustomRadioGroup.vue?vue&type=style&index=0&id=7d9c591a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d9c591a"]])

export default __exports__